import { connect } from "react-redux";
import Notification from "../components/elements/Notification";

const mapStateToProps = state => ({
    notification: state.ui.notification,
});

export default connect(mapStateToProps, null)(Notification);
